// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import PipelineEditor from './pages/PipelineEditor';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Analytics from './pages/Analytics';
import Models from './pages/Models';
import LandingPage from './pages/LandingPage';
import LandingPage2 from './pages/PublicLandingPage';
import Documentation from './pages/Documentation';
import AdminDashboard from './pages/AdminDashboard';
import MergeDatasets from './pages/MergeDatasets';
import UserFeedbackForm from './pages/UserFeedbackForm';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyOtp from './pages/VerifyOtp';
import Pipelines from './pages/Pipelines';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';


const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/home" element={
            <ProtectedRoute>
              <Layout>
                <Home />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/" element={
            
              
                <LandingPage />
              
            
          } />
          <Route path="/prv" element={
            
              
            <LandingPage2 />
          
        
      } />
          <Route path="/projects" element={
            <ProtectedRoute>
              <Layout>
                <Projects />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/project/:projectId" element={
            <ProtectedRoute>
              <Layout>
                <ProjectDetail />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/pipeline/:pipelineId" element={
            <ProtectedRoute>
              <Layout>
                <PipelineEditor />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/models" element={
            <ProtectedRoute>
              <Layout>
                <Models />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/pipelines" element={
            <ProtectedRoute>
              <Layout>
                <Pipelines />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          } />
            <Route path="/documentation" element={
            
            <ProtectedRoute>
              <Layout>
              <Documentation />
              </Layout>
            </ProtectedRoute>
            } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <Layout>
                <AdminDashboard />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/feedback" element={
            <ProtectedRoute>
              <Layout>
                <UserFeedbackForm />
              </Layout>
            </ProtectedRoute>
          } />
      
          <Route path="/merge-datasets" element={
  <ProtectedRoute>
    <Layout>
      <MergeDatasets />
    </Layout>
  </ProtectedRoute>
} />


        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;